import { useCubeQuery } from '@cubejs-client/react';
import { ReactNode } from 'react';

import { CompanySourceSystemField } from '~/common/types/cubes/CompanySourceSystem';
import { SummaryCompanyField } from '~/common/types/cubes/SummaryCompany';
import { BaseDetailHeader, BaseDetailHeaderProps } from '~/components/BaseDetailHeader/BaseDetailHeader';

export interface CompanyDetailHeaderProps {
  id: string;
  tabs?: BaseDetailHeaderProps['tabs'];
  actionsRight?: ReactNode;
}

export const CompanyDetailHeader = ({ id, tabs, actionsRight }: CompanyDetailHeaderProps) => {
  const nameQuery = useCubeQuery({
    dimensions: [SummaryCompanyField.NAME],
    filters: [{ member: SummaryCompanyField.ID, operator: 'equals', values: [id] }],
  });
  const linksQuery = useCubeQuery({
    dimensions: [
      CompanySourceSystemField.SOURCE_REFERENCE,
      CompanySourceSystemField.LINK,
      CompanySourceSystemField.SOURCE_SYSTEM,
    ],
    filters: [{ member: CompanySourceSystemField.INTERNAL_ID, operator: 'equals', values: [id] }],
  });

  const loading = nameQuery.isLoading || linksQuery.isLoading;
  const name = (nameQuery.resultSet?.rawData()?.[0]?.[SummaryCompanyField.NAME] as string) ?? '';

  const linkRows = linksQuery.resultSet?.rawData() ?? [];
  const links = linkRows.map((row) => ({
    title: `${row[CompanySourceSystemField.SOURCE_REFERENCE] ?? ''}`,
    url: `${row[CompanySourceSystemField.LINK] ?? ''}`,
  }));

  return <BaseDetailHeader loading={loading} title={name} tabs={tabs} links={links} actionsRight={actionsRight} />;
};
